import swasticLogo from "./swastic.svg";

const formatItemTime = (t, showMidnight) => {
  const isEmpty = t === undefined || t === "" || t === "00:00";
  if (isEmpty && !showMidnight) return "";
  return `— ${t || "00:00"}`;
};

const DiaryFormat = ({ panchangData, showMidnight = true }) => {
  return (
    <div className="diary-format-wrap">
      {panchangData.map((entry, index) => {
        const muhurtaEntries = Object.entries(entry.muhurta || {}).reduce((acc, [key, value]) => {
          const idx = key.match(/\d+/)?.[0];
          if (!idx) return acc;
          if (!acc[idx]) acc[idx] = {};
          acc[idx][key.includes("start") ? "start" : "end"] = value || (key.includes("end") ? "24:00" : "");
          return acc;
        }, {});
        return (
          <div key={index} className="diary-page page-break">
            <div className="diary-page-inner">
              <header className="diary-header">
                <div className="diary-date-box">
                  <span className="diary-date">{entry.date}</span>
                  <span className="diary-weekday">{entry.weekday}</span>
                </div>
                <img src={swasticLogo} alt="Swastik Logo" className="diary-swastik" />
                <div className="diary-timings">
                  <p><strong>Rahukalam:</strong> {entry.rahukalam}</p>
                  <p><strong>Yamagandam:</strong> {entry.yamagandam}</p>
                </div>
              </header>

              <div className="diary-ruled">
                {Array.from({ length: 8 }).map((_, i) => (
                  <div key={i} className="diary-line" />
                ))}
              </div>

              <section className="diary-panchang-section">
                <table className="diary-table">
                  <tbody>
                    <tr>
                      <td className="diary-cell">
                        <strong className="diary-label">Nakshatra</strong>
                        <ul>
                          {(entry.nakshatra || []).map((item, i) => (
                            <li key={i}>{item[0]} {formatItemTime(item[1], showMidnight)}</li>
                          ))}
                        </ul>
                      </td>
                      <td className="diary-cell">
                        <strong className="diary-label">Tithi</strong>
                        <ul>
                          {(entry.tithi || []).map((item, i) => (
                            <li key={i}>{item[0]} {formatItemTime(item[1], showMidnight)}</li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td className="diary-cell">
                        <strong className="diary-label">Yoga</strong>
                        <ul>
                          {(entry.yoga || []).map((item, i) => (
                            <li key={i}>{item[0]} {formatItemTime(item[1], showMidnight)}</li>
                          ))}
                        </ul>
                      </td>
                      <td className="diary-cell">
                        <strong className="diary-label">Karana</strong>
                        <ul>
                          {(entry.karana || []).map((item, i) => (
                            <li key={i}>{item[0]} {formatItemTime(item[1], showMidnight)}</li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>

              <div className="diary-favorable favorable-box">
                {Object.keys(muhurtaEntries).length > 0 ? (
                  <>
                    <h5 className="diary-favorable-title">Favorable Timings</h5>
                    <ul>
                      {Object.entries(muhurtaEntries).map(([idx, { start, end }]) => (
                        <li key={idx}>
                          {(start && start !== "00:00" ? start : showMidnight ? (start || "00:00") : "")} – {end || "24:00"}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <p className="diary-no-favorable">No favourable timings</p>
                )}
                {entry.activities && entry.activities.length > 0 && (
                  <div className="diary-activities">
                    {entry.activities.map((act, i) => (
                      <p key={i}>{typeof act === "string" ? act : (act?.join?.(" ") || String(act))}</p>
                    ))}
                  </div>
                )}
                {entry.inauspicious && (
                  <p className="diary-inauspicious">{entry.inauspicious}</p>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DiaryFormat;
